import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { AddressFieldComponent } from './components/address-field/address-field.component';
import { MapCardComponent } from './components/map-card/map-card.component';

const components = [AddressFieldComponent, MapCardComponent];

@NgModule({
  imports: [CommonModule, SharedModule, FormMasterModule],
  declarations: [...components],
  exports: [...components],
})
export class GeolocationModule {}
